import {useMemo} from 'react';
import {ApiClientService} from '@dofleini/security';
import {authentication} from '@/settings';
import {useQuery} from 'react-query';
import checkAuthClientInfo from '@/utils/checkAuthClientInfo';

const USER_PROFILE = '__user_profile__';

export const useMe = () => {
  const path = `${authentication.path}/api/users/me`;

  const user = useMemo(() => {
    const user = localStorage.getItem(USER_PROFILE);
    if (user)
      try {
        return JSON.parse(user);
      } catch (e) {
        //ignoring
      }
  }, []);

  const {isLoading, error, data, refetch, isStale} = useQuery('user-me', async () => {
    checkAuthClientInfo();
    if (!ApiClientService.getToken()) return Promise.reject({authenticatedError: true});
    const {data} = await ApiClientService.get(path);
    localStorage.setItem(USER_PROFILE, JSON.stringify(data));
    return (data);

  }, {
    retry: 0, // Will retry failed requests 10 times before displaying an error
    refetchOnWindowFocus: false
  });

  return {
    data: error?.status || error?.authenticatedError ? undefined : data || user,
    isLoading, error, refetch, isStale
  };
};

